// Playback Rate Popover
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';

export const PlaybackRatePopover = ({ rates, playbackRate, setPlaybackRate, mini }) => (
  <Popover className={`${mini ? 'col-start-4 row-start-3' : 'col-start-8 row-start-3'} relative`}>
    <PopoverButton
      className="focus-visible:outline-pdTeal cursor-pointer rounded p-1 hover:bg-gray-100 focus-visible:outline-2"
      aria-label="Change playback speed"
    >
      {rates.find((r) => r.value === playbackRate)?.label ?? '1.0x'}
    </PopoverButton>
    <PopoverPanel
      anchor="bottom"
      className="z-110 mb-2 flex origin-bottom flex-col rounded-lg border border-gray-200 bg-white p-2 transition duration-200 ease-out data-closed:scale-y-50 data-closed:opacity-0"
      transition
      role="menu"
      aria-label="Playback speed options"
    >
      {({ close }) => (
        <>
          {rates.map((r) => (
            <button
              key={r.value}
              onClick={() => {
                setPlaybackRate(r.value);
                close();
              }}
              className="focus-visible:outline-pdTeal cursor-pointer rounded-lg p-1 text-left hover:bg-gray-100 focus-visible:outline-2"
              role="menuitem"
              aria-current={playbackRate === r.value ? 'true' : 'false'}
            >
              {r.label}
            </button>
          ))}
        </>
      )}
    </PopoverPanel>
  </Popover>
);
